module.exports = __webpack_public_path__ + "static/media/twist.958c7bca.png";